var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { width, maxWidth, height, maxHeight } from 'styled-system';
import { LocaleConsumer } from '../../../common/providers/LocaleProvider';
import themedComponent from '../../../common/components/hoc/themedComponent';
import { getTrackerProps } from '../../../common/tracking/getTrackerProps';
import h24Logo from '../../../common/assets/images/home-24-logo.svg';
import ffhLogo from '../../../common/assets/images/fashionforhome.svg';
var LogoLink = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var LogoImg = styled.img(width, maxWidth, height, maxHeight);
var H24Logo = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
H24Logo.defaultProps = {
    src: h24Logo,
    as: LogoImg,
    width: ['86.5px', '93px', '118px'],
    maxWidth: ['86.5px', '93px', '118px'],
    height: ['30.8px', '33px', '42px'],
    maxHeight: ['30.8px', '33px', '42px'],
};
var FFHLogo = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
FFHLogo.defaultProps = {
    src: ffhLogo,
    as: LogoImg,
    width: ['45px', null, '122px'],
    maxWidth: ['45px', null, '122px'],
    height: ['32px', null, '88px'],
    maxHeight: ['32px', null, '88px'],
};
var BrandLogo = themedComponent(H24Logo, FFHLogo);
var Logo = function () {
    return (React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(LogoLink, __assign({}, getTrackerProps({
        'data-testid': 'toolbar-logo',
        href: l10n.prefix.t('h24_home_url'),
    }, {
        event: 'headerTracking',
        eventCategory: 'icon',
        eventData: { placement: 'header', iconIdentifier: 'logo' },
    })),
        React.createElement(BrandLogo, { alt: l10n.t('h24_logo_alt_title') }))); }));
};
export default Logo;
var templateObject_1, templateObject_2, templateObject_3;
